import { INote } from "../../types/INote";
import DateTime from "../../services/date-time";
import styles from "./index.module.scss";

type TNoteHeadProps = {
  note: INote;
};

export default function NoteHead({ note }: TNoteHeadProps): JSX.Element {
  const contentType = note.timeTemplate?.type || "date";

  return (
    <div className={styles.head} data-e="note-head">
      {contentType === "date" && (
        <span className={styles.date} data-e="note-date">
          {DateTime.adaptiveDateTime(new Date(note.publicationDate))}
        </span>
      )}
      {contentType === "minutes" && note.timeTemplate?.minutes.base && (
        <div className={styles.minutes} data-e="note-minutes">{`${note.timeTemplate.minutes.base}'${
          note.timeTemplate.minutes.extra ? ` + ${note.timeTemplate.minutes.extra}` : ""
        }`}</div>
      )}
      {note.urgent && !note.noteIcon && (
        <div className={styles.label} data-e="note-urgent">
          Pilne
        </div>
      )}
      {contentType === "text" && note.timeTemplate?.value && (
        <div className={styles.text} data-e="note-text">
          {note.timeTemplate.value}
        </div>
      )}

      {note.noteIcon && <img className={styles.icon} src={note.noteIcon} alt={note.title} data-e="note-icon" />}
    </div>
  );
}
